module.exports = __webpack_public_path__ + "static/img/Boston.63be449.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Boston.png
// module id = dTkG
// module chunks = 1